import httpServices from 'services/http.service';
import { API_URLS } from 'config/constants';

export const getToysiCategories = () => httpServices.get(API_URLS.TOYSI.CATEGORIES);

export const getToysiProducts = (category: string) => httpServices.get(API_URLS.TOYSI.PRODUCTS, { params: { category } });

export const getToysiImportedSkus = () => httpServices.get(API_URLS.TOYSI.IMPORTED_SKUS);

export const importFromToysi = (body: {
  toysiCategoryId: string;
  ourCategoryId: string;
  toysiProductIds: string[];
}) => httpServices.post(API_URLS.TOYSI.BULK_CREATE, body);
